import { render, staticRenderFns } from "./UserMergeCard.vue?vue&type=template&id=7bfa9ee4"
import script from "./UserMergeCard.vue?vue&type=script&lang=js"
export * from "./UserMergeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports